export const STORE_CONFIG = 'STORE_CONFIG';
export const LOAD_CONFIG = 'LOAD_CONFIG';
